import { render, staticRenderFns } from "./BenefitProcess.vue?vue&type=template&id=1a3237c9&scoped=true"
import script from "./BenefitProcess.vue?vue&type=script&lang=js"
export * from "./BenefitProcess.vue?vue&type=script&lang=js"
import style0 from "./BenefitProcess.vue?vue&type=style&index=0&id=1a3237c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3237c9",
  null
  
)

export default component.exports